<!-- Marketing Footer -->
<footer class="marketing-footer">
  <div class="footer-container">
    <!-- Three Column Grid -->
    <div class="footer-grid">
      <!-- Column 1: Company -->
      <div class="footer-column">
        <h4 class="column-heading">Company</h4>
        <ul class="link-list">
          <li><a routerLink="/home">Home</a></li>
          <li><a routerLink="/about">About</a></li>
          <li><a routerLink="/account">Account</a></li>
        </ul>
      </div>

      <!-- Column 2: Account -->
      <div class="footer-column">
        <h4 class="column-heading">Join Us</h4>
        <ul class="link-list">
          <li><a routerLink="/about" [queryParams]="{ tab: 'partners' }">Suppliers</a></li>
          <li><a routerLink="/about" [queryParams]="{ tab: 'partners' }">Partners</a></li>
          <li><a routerLink="/about" [queryParams]="{ tab: 'careers' }">Careers</a></li>
        </ul>
      </div>

      <!-- Column 3: Legal -->
      <div class="footer-column">
        <h4 class="column-heading">Legal</h4>
        <ul class="link-list">
          <li><a routerLink="/privacy">Privacy Policy</a></li>
          <li><a routerLink="/terms">Terms of Service</a></li>
          <li><a routerLink="/security">Security</a></li>
        </ul>
      </div>

      <!-- Column 3: Contact -->
      <div class="footer-column">
        <h4 class="column-heading">Contact</h4>
        <ul class="link-list">
          <li>
            <a href="mailto:businessdevelopment@entropygrouplimited.com">
              businessdevelopment&#64;entropygrouplimited.com
            </a>
          </li>
          <li><a href="tel:+16514783137">+1 (651) 478-3137</a></li>
          <li><span class="text-muted">Mon-Sun, 12:00am-11:59pm CT</span></li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Copyright Bar -->
  <div class="copyright-bar">
    <div class="footer-container">
      <div class="copyright-row">
        <p class="copyright-text">
          &copy; {{ currentYear }} EntropyGroupLimited Inc. All rights reserved.
        </p>
        <div class="certifications">
          <span>UEI: QQ2HGN33Q145</span>
          <span class="separator">•</span>
          <span>CAGE: 10001</span>
          <span class="separator">•</span>
          <span>DUNS: 119408166</span>
        </div>
      </div>
    </div>
  </div>
</footer>
